import { useEffect, useRef, useState } from "react";
import { FilterBtn } from "../../components/ui/Buttons";
import type { CshGroupSummary } from "../../services/csh/csh.types";

interface Props {
    options: CshGroupSummary[];
    selectedIds: string[];
    loading: boolean;
    onChange: (ids: string[]) => void;
}

export function HomeGroupFilter({ options, selectedIds, loading, onChange }: Props) {
    const [open, setOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!open) return;
        const onMouseDown = (event: MouseEvent) => {
            if (event.target instanceof Node && !containerRef.current?.contains(event.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onMouseDown);
        return () => document.removeEventListener("mousedown", onMouseDown);
    }, [open]);
    return (
        <div className="alarm-controls">
            <div className="filter-container mb-1" ref={containerRef}>
                <FilterBtn onClick={() => setOpen(previous => !previous)} isDropdownOpen={open} isActive={!!selectedIds.length} />
                {open && <div className="filter-dropdown"><div className="filter-dropdown__content">
                    <h4 className="filter-dropdown__title">Filter CSH Groups</h4>
                    <div className="filter-dropdown__form"><div className="filter-dropdown__section">
                        <div className="filter-dropdown__checkboxes">
                            <label className="filter-dropdown__checkbox-label">
                                <input className="filter-dropdown__checkbox" type="checkbox" checked={!selectedIds.length} onChange={() => onChange([])} />
                                <span className="filter-dropdown__checkbox-text">All CSH Groups</span>
                            </label>
                            {options.map(group => {
                                const id = String(group.id);
                                return <label className="filter-dropdown__checkbox-label" key={id}>
                                    <input className="filter-dropdown__checkbox" type="checkbox" disabled={loading} checked={selectedIds.includes(id)}
                                        onChange={() => onChange(selectedIds.includes(id) ? selectedIds.filter(value => value !== id) : [...selectedIds, id])} />
                                    <span className="filter-dropdown__checkbox-text">{group.name}</span>
                                </label>;
                            })}
                        </div>
                    </div></div>
                </div></div>}
            </div>
        </div>
    );
}
